export default {
  name: 'wisk-chevron-up',
  width: 35,
  height: 35,
  paths: [{ d: 'M31.837,27.883a3.155,3.155,0,0,1-2.248-.937L17.5,14.738,5.411,26.946a3.164,3.164,0,0,1-4.5-4.453L15.252,8.016a3.259,3.259,0,0,1,4.5,0L34.085,22.493a3.164,3.164,0,0,1-2.248,5.39Z' }]
}
